import Vue from "vue";
import { Component } from "vue-property-decorator";
import { FetchWrapper } from "../../infrastructure/fetch-wrapper";
import { DashboardServices} from "../../scripts/dashboardServices";
import { ClientNotifier } from "../../scripts/ah.mb.client-notifications";
import { bootbox } from "../../infrastructure/bootbox-shim";

interface IDashboardDataSet {
    dataSetId: string;
    kind: string;
    creationDate: Date;
    lastModifiedDate: Date;
    defaultTableExpirationDays: number;
}

interface IDashboardTable {
    tableId: string;
    creationDate: Date;
    lastModifiedDate: Date;
}

interface IDashboardDataSetInfo {
    dataSetId: string;
    tables: IDashboardTable[];
}

@Component
export default class DashboardDataSetsDiaog extends Vue {


    datasets: IDashboardDataSet[] = [];

    dashboardServices = new DashboardServices();
    userNotifier = new ClientNotifier();


    mounted() {
        this.refreshDatasets();
    }

    refreshDatasets() {
        FetchWrapper.fetch("/api/1.0/dashboard/datasets", { method: "get" })
            .then(response => response.json())
            .then(response => this.datasets = response);
    }

    deleteDatasetClick(dataset: IDashboardDataSet) {
        bootbox.confirm2(`Delete dataset ${dataset.dataSetId}?  This can impact dashboards that use the dataset.`)
            .then(() => {
                var body = JSON.stringify({ datasetId: dataset.dataSetId });
                FetchWrapper.sendCommandAndHandle("/api/1.0/dashboard/deletedataset",
                    {
                        method: "post",
                        body: body
                    })
                    .then(response => {
                        if (response.success)
                            this.refreshDatasets();
                    })
            });

    }

    showDataSetInfo(dataset: IDashboardDataSet) {
        FetchWrapper.fetch(`/api/1.0/dashboard/datasetinfo?dataSetId=${dataset.dataSetId}`, { method: "get" })
            .then(response => response.json())
            .then((response: IDashboardDataSetInfo) => {
                var msg = response.tables.map(p => `<p>${p.tableId}, created: ${p.creationDate}, modified: ${p.lastModifiedDate}</p>`);
                var joined = msg.join("");
                bootbox.alertDialog(`${dataset.dataSetId} Tables`, joined);
            });

    }

    changeDataSetDefaultExpiration(dataset: IDashboardDataSet) {
        bootbox.prompt({
            title: " Set default dataset expiration in days",
            content: dataset.defaultTableExpirationDays.toString(),
            callback: val => {

                var payload = {
                    datasetId: dataset.dataSetId,
                    defaultTableExpirationDays: val
                };

                FetchWrapper.sendCommandAndHandle(`/api/1.0/dashboard/setdatasetdefaultexpiration`, { method: "post", body: JSON.stringify(payload) });
            }
        })
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/dashboard-datasets-dialog/dashboard-datasets-dialog.ts